import React from "react";
import "./companyItem.scss";


function JobItem(props) {
  let item = props.item;
  return (
    <div
      className="jobItem"
      onClick={(e) => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
        window.location.href = item.pcUrl;
      }}
    >
      <div className="jobName">{item.infoTitle}</div>
      <div className="salary">{item.salary}</div>
    </div>
  );
}

export default class CompanyItem extends React.Component {
  render() {
    let item = this.props.item;
    return (
      <div className="companyItem"  
      onClick={() => {
        window.location.href = item.companyPCUrl;
      }}>
        <div className="companyItem_top">
          <img className="qyLogo" alt="" src={item.companyLogo}></img>
          <div className="titleRight">
            <div className="qyName">{item.companyName}</div>
          </div>
        </div>
        <div className="companyItem_jobList">
          <JobItem item={item.positionList[0]}/>
          <JobItem item={item.positionList[1]}/>
          <JobItem item={item.positionList[2]}/>
          {/* {item.positionList.map((item, index) => {
            return <JobItem item={item} key={index} />;
          })} */}
        </div>
        <div
          className="companyItem_clickMore"
        >
          查看更多职位 》
        </div>
      </div>
    );
  }
}
